import LockIcon from '@mui/icons-material/Lock';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { Box, Typography } from '@mui/material';

type DeviceStepButtonProps = {
    label: string;
    active: boolean;
    locked: boolean;
    switchable: boolean;
    onClick: () => void;
};

const DeviceStepButton = ({ label, active, locked, switchable, onClick }: DeviceStepButtonProps) => {
    const disabled = !switchable && !active;

    return (
        <Box
            component="button"
            type="button"
            disabled={disabled}
            onClick={(event) => {
                event.currentTarget.blur();
                onClick();
            }}
            sx={{
                width: 44,
                p: 0,
                border: 0,
                outline: 0,
                bgcolor: 'transparent',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.45 : 1,
                WebkitTapHighlightColor: 'transparent',

                '&:focus, &:focus-visible': {
                    outline: 'none',
                },
            }}
        >
            <Box
                sx={{
                    width: 36,
                    height: 36,
                    mx: 'auto',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: active ? '2px solid #0B5BD3' : '1px solid #CBD5E1',
                    bgcolor: locked ? '#DBEAFE' : '#FFFFFF',
                    color: locked ? '#94A3B8' : '#0B5BD3',
                }}
            >
                {locked ? (
                    <LockIcon sx={{ fontSize: 18 }} />
                ) : active ? (
                    <RadioButtonCheckedIcon sx={{ fontSize: 20 }} />
                ) : (
                    <Box
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            bgcolor: '#CBD5E1',
                        }}
                    />
                )}
            </Box>

            <Typography
                sx={{
                    mt: 0.75,
                    fontSize: 14,
                    lineHeight: 1.2,
                    fontWeight: active ? 800 : 700,
                    color: active ? '#111827' : '#64748B',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};

export default DeviceStepButton;
